import { FaqServiceSupportThemeSizeConfig } from './types';

const medium: FaqServiceSupportThemeSizeConfig = {
  faqServiceSupport: {},
};

export default medium;
